import { Phone } from 'lucide-react';
import { FC } from 'react';

import { Description, IconWrapper, Number, PhoneBookCardWrapper, Title } from './PhoneBookcard.styled';

export type PhoneBookCardProps = {
  icon: React.ReactElement;
  title: string;
  action: () => void;
  description: string;
  isInternal?: boolean;
  number: string;
};

export const PhoneBookCard: FC<PhoneBookCardProps> = ({ icon, title, action, description, isInternal, number }) => {
  console.log(isInternal);
  return (
    <PhoneBookCardWrapper onClick={isInternal ? undefined : action} data-testid="phone-book-card">
      <IconWrapper>
        {icon}
        {isInternal ? <Number>{number}</Number> : <Phone />}
      </IconWrapper>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </PhoneBookCardWrapper>
  );
};
